export default __webpack_public_path__ + "static/media/heatingFr.5b9d090a.jpg";